<template>
    <div>
        <b-tabs class="emisiones" v-model="tabIndex">
            <b-tab active>
                <template slot="title">
                    <h6 class="colorEmision">Documentos Emitidos</h6>
                    <div class="separador"></div>
                </template>
                <template v-if="tabIndex === 0">
                    <documentos :tipoRecepcion="tabIndex"/>
                </template>
            </b-tab>
            <b-tab title="Documentos Recibidos">
                <template v-if="tabIndex === 1">
                    <documentos :tipoRecepcion="tabIndex"/>
                </template>
            </b-tab>
            <b-tab title="Productos">
                <template v-if="tabIndex === 2">
                    <vendidos/>
                </template>
            </b-tab>
            <b-tab title="Caja Bancos">
                <template v-if="tabIndex === 3">
                <caja-bancos></caja-bancos>
                </template>
            </b-tab>
             <b-tab title="Cajas">
                <template v-if="tabIndex === 4">
                <caja></caja>
                </template>
            </b-tab>
            <b-tab title="Análisis">
                <template v-if="tabIndex === 5">
                <analisis></analisis>
                </template>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import Documentos from '@/components/reportes/Documentos'
import Vendidos from '@/components/reportes/Vendidos'
import CajaBancos from '@/components/reportes/CajaBancos'
import Caja from '@/components/reportes/Caja'
import Analisis from '@/views/Dashboard'
    export default {
        name: 'Reportes',
        components: {
            Documentos,
            Vendidos,
            CajaBancos,
            Caja,
            Analisis
        },
        data:() => {
            return {
                tabIndex: 0
            }
        }
    }
</script>
